<template>
  <v-container class="whitesmoke black--text" id="deny-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <div class="text-center" id="vdog">
      <v-dialog v-model="dialog" width="800">
        <v-card>
          <v-card-title class="text-h5 white--text accent">
            Send Denail Email
          </v-card-title>

          <v-card-text>
            <div class="d-flex flex-column justify-start align-start">
              <div
                class="d-flex flex-row justify-start align-baseline flex-wrap"
              >
                <label>From: </label>
                <article class="ml-2">Rpdinnotech@reno.gov</article>
              </div>
              <div
                class="d-flex flex-row justify-start align-baseline flex-wrap"
              >
                <label>To: </label>
                <v-text-field
                  class="ml-2"
                  label=""
                  v-model="to_email"
                ></v-text-field>
              </div>
              <v-textarea
                class="txarea"
                name="Message"
                label="Message"
                v-model="body"
                auto-grow
                solo
              ></v-textarea>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="sendemail"> Send </v-btn>
            <v-btn color="accent" @click="closediag"> Cancel </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
@media (min-width: 0px) {
  #deny-container {
    width: 100%;
  }
  .txarea {
    width: 100%;
  }
  label {
    font-weight: 600;
    font-size: 1.05rem;
  }
  article {
    color: black;
  }
}

//  768 media q
@media (min-width: 768px) {
  .vdog {
    height: 1000px;
  }
  v-dialog v-dialog--active {
    height: 1000px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "deny_email",
  mixins: [bus_common],
  props: ["request"],
  data() {
    return {
      dialog: true,
      to_email: "",
      body: `Dear <<fname>> <<lname>>,
We are in receipt of a request, case #<<casenum>>, to return property in the custody of the Reno Police Department. This letter is to inform you that the request has been denied and your firearm(s) will not be returned at this time.

Reason:


Per NRS 202.340 – Confiscation and disposition of dangerous weapons by Law Enforcement Agencies. The Reno Police Department requested that you obtain a court order from the judge who convicted you for this case #19-6281 to release the below listed weapons back to you. You have thirty days (30) to file this request with the court.

Item:


Do not reply to this message.
For questions or concerns, please email RPDfirearmreviewunit@reno.gov.

Respectfully,

`,
    };
  },
  methods: {
    closediag() {
      this.$emit("closediag");
    },
    sendemail() {
      this.closediag();
      this.show_loader(true);
      var formIn = {};
      formIn.to_email = this.to_email;
      formIn.body = this.body;
      formIn.apiname = "send_deny";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.swall_it("Send Email Status", "Sent.", "success", null, null);
        })
        .catch((msg) => {
          this.swall_it("Please Report this error.", msg, "error", null, null);
        });
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.to_email = this.request.email;
      this.body = this.body.replace("<<fname>>", this.request.fname);
      this.body = this.body.replace("<<lname>>", this.request.lname);
      this.body = this.body.replace("<<casenum>>", this.request.casenum);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
